import React, { useRef, useState } from "react";
import { useGetPayrollDetailQuery } from "AppQuries/payroll/get-payroll";
import PayslipTemplateOne from "Components/UI/Payslip/PayslipTemplateOne";
import Error404 from "MainPages/ErrorPages/error404";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import PropTypes from "prop-types";
import { useSearchParams } from "react-router-dom";
import { Printer } from "react-feather";
import { format } from "date-fns";
const PayslipViewer = () => {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const pdfRef = useRef();

  const {
    data: payrollDetails,
    isFetching,
    isError,
    error,
  } = useGetPayrollDetailQuery({
    companyCode: searchParams.get("companyCode"),
    locationCode: searchParams.get("locationCode") || "",
    refNo: searchParams.get("refNo"),
    employeeCode: searchParams.get("employeeCode"),
  });

  const pdfDownloader = () => {
    setIsLoading(true);
    setTimeout(() => {
      const input = pdfRef.current;
      html2canvas(input, { scale: 2, useCORS: true, logging: true }).then(
        (canvas) => {
          const imgData = canvas.toDataURL("image/png", 1.0);
          const pdf = jsPDF("p", "mm", "a4", true);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();
          const imgWidth = canvas.width;
          const imgHeight = canvas.height;
          const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
          const imgX = (pdfWidth - imgWidth * ratio) / 2;
          const imgY = 30;
          pdf.addImage(
            imgData,
            "PNG",
            imgX,
            imgY,
            imgWidth * ratio,
            imgHeight * ratio,
            undefined,
            "SLOW"
          );
          const paySlipName = `${
            payrollDetails?.employeeHeader?.[0]?.fullName
          } Payslip -${format(
            new Date(payrollDetails?.employeeHeader?.[0]?.toDate),
            "MMM"
          )}-${format(
            new Date(payrollDetails?.employeeHeader?.[0]?.toDate),
            "yyyy"
          )}.pdf`;
          pdf.save(paySlipName);
        }
      );
    }, 1000);
    setIsLoading(false);
  };
  if (isError) return <Error404 error={error} />;
  if (isFetching || isLoading) return <LoadingSpinner />;
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Payslip</h4>
              <h6>Download employee payslip</h6>
            </div>
          </div>

          <div className="page-btn">
            <button
              className="btn btn-secondary me-md-2"
              type="button"
              disabled={isLoading}
              onClick={pdfDownloader}
            >
              
              <Printer className="me-2" />
              {isLoading && (
                <>
                  <i className="fas fa-spinner fa-spin me-2"></i>
                  Loading...
                </>
              )}
              {!isLoading && <>Download</>}
            </button>
          </div>
        </div>
        <div ref={pdfRef}>
          <PayslipTemplateOne
            payrollDetails={payrollDetails?.employeeHeader?.[0]}
          />
        </div>
      </div>
    </div>
  );
};

// Payslip.propTypes = {
//   companyCode: PropTypes.number.isRequired,
//   refNo: PropTypes.number.isRequired,
//   employeeCode: PropTypes.number.isRequired,
// };

export default PayslipViewer;
